import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {Percentage} from 'shells/percentage/percentage';
import {TwoLineInfo} from 'shells/two-line-info/two-line-info';

import styles from './peep-em-stats.module.css';

type Props = {
    totalSentCount: number | null | undefined;
    openRate: number | null | undefined;
    clickRate: number | null | undefined;
    replyRate: number | null | undefined;
};

export function PeepEmStats(props: Props) {
    React.useEffect(() => {
        ReactTooltip.rebuild();
    }, []);

    return (
        <div className={styles.container}>
            <TwoLineInfo
                label={
                    <div data-tip='All emails sent from inside of Nutshell that include open or click tracking'>
                        Emails sent
                    </div>
                }
                rightAligned={true}
            >
                {props.totalSentCount || 0}
            </TwoLineInfo>
            <TwoLineInfo label='Open rate' rightAligned={true}>
                {/* @ts-expect-error */}
                <Percentage value={props.openRate} />
            </TwoLineInfo>
            <TwoLineInfo label='Click rate' rightAligned={true}>
                {/* @ts-expect-error */}
                <Percentage value={props.clickRate} />
            </TwoLineInfo>
            <TwoLineInfo label='Reply rate' rightAligned={true}>
                {/* @ts-expect-error */}
                <Percentage value={props.replyRate} />
            </TwoLineInfo>
        </div>
    );
}
